import React from 'react';
import { useGame } from '@/app/providers/GameContextProvider';
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';

const EndlessModeAdvancedSettings: React.FC = () => {
    const { room, gameState } = useGame();
    const { isGameMaster } = useGameModeSettingsContext();

    if (!room || !gameState) return null;

    return (
        <div className={`flex flex-col gap-4 ${!isGameMaster ? 'opacity-50' : ''}`}>
            {/* Endless mode has no configurable settings */}
        </div>
    );
};

export default EndlessModeAdvancedSettings;
